<template>
    <ul class="filter">
        <li class="filter__item" v-if="industryTagFacet.length > 0">
            <label for="industryTagFilter" class="sr-only">{{ dictionary.IndustryDefaultTag }}</label>
            <select id="industryTagFilter" class="filter__item-inner" v-model="industryTag" :disabled="isLoading">
                <option value="Industry">{{ dictionary.IndustryDefaultTag }}</option>
                <option v-for="tagItem in industryTagFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="competenceTagFacet.length > 0">
            <label for="competenceTagFilter" class="sr-only">{{ dictionary.CompetenceDefaultTag }}</label>
            <select id="competenceTagFilter" class="filter__item-inner" v-model="competenceTag" :disabled="isLoading">
                <option value="Competence">{{ dictionary.CompetenceDefaultTag }}</option>
                <option v-for="tagItem in competenceTagFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="productTypeFacet.length > 0">
            <label for="productTypeFilter" class="sr-only">{{ dictionary.ProductDefaultType }}</label>
            <select id="productTypeFilter" class="filter__item-inner" v-model="productType" :disabled="isLoading">
                <option value="ProductType">{{ dictionary.ProductDefaultType }}</option>
                <option v-for="tagItem in productTypeFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item filter__item-reset" v-if="hasFilterApplied">
                <button type="button" @click="resetFilter">{{ dictionary.ResetArticles }}</button>
            </li>
    </ul>
    <ul class="articles-items">
        <li v-for="article in articles" :key="article.Url">
            <article class="article-item">
                <a :href="article.Url" class="article-item__link">
                    <div class="article-item__inner">
                        <div class="article-item__image">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                        </div>
                        <div class="article-item__text">
                            <div class="article-item__customer" v-if="article.HasCustomerName">
                                {{ article.CustomerName }}
                            </div>
                            <h3 class="article-item__headline">{{ article.Headline }}</h3>
                        </div>
                        <div class="article-item__link-text">{{ linkText && linkText.trim() !== '' ? linkText : dictionary.LatestArticlesLink }}</div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-section__footer">
            <div class="articles-section__footer-load-more" v-show="hasMoreArticles">
                <a @click="getNextPage" :disabled="isLoading">
                {{ loadMoreText && loadMoreText.trim() !== '' ? loadMoreText : dictionary.LoadMoreArticles }}</a>
            </div>
        </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesapi/GetArticles";
const defaultIndustryTag = "Industry";
const defaultCompetenceTag = "Competence";
const defaultProductType = "ProductType";
export default {
    name: "Articles",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            industryTagFacet: [],
            competenceTagFacet: [],
            productTypeFacet: [],
            culture: "da-DK",
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            isLoading: false,
            hasLoadedInitials: false,
            articlesNodeId: 0,
            isResetting: false,
            linkText: "",
            loadMoreText: ""
        };
    },
    mixins: [
        bindRoute({
            industryTag: defaultIndustryTag,
            competenceTag: defaultCompetenceTag,
            productType: defaultProductType
        }),
    ],
    watch: {
        industryTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        competenceTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        productType: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.articlesNodeId = this.$parent.articlesNodeId;
        this.pageSize = this.$parent.pageSize;
        this.linkText = this.$parent.linkText;
        this.loadMoreText = this.$parent.loadMoreText;

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize
            };

            if (vm.industryTag != defaultIndustryTag) {
                object.industryTag = vm.industryTag;
            }

            if (vm.competenceTag != defaultCompetenceTag) {
                object.competenceTag = vm.competenceTag;
            }

            if (vm.productType != defaultProductType) {
                object.productType = vm.productType;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.industryTagFacet = data.Facets.IndustryTag;
                    vm.competenceTagFacet = data.Facets.CompetenceTag;
                    vm.productTypeFacet = data.Facets.ProductType;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.industryTag = defaultIndustryTag;
            vm.competenceTag = defaultCompetenceTag;
            vm.productType = defaultProductType;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.industryTag != defaultIndustryTag ||
                this.competenceTag != defaultCompetenceTag ||
                this.productType != defaultProductType;
        }
    },
};
</script>